import { render } from "./TabbyTask.vue?vue&type=template&id=fdd0eba0&scoped=true"
import script from "./TabbyTask.vue?vue&type=script&lang=js"
export * from "./TabbyTask.vue?vue&type=script&lang=js"

import "./TabbyTask.vue?vue&type=style&index=0&id=fdd0eba0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fdd0eba0"

export default script